import React, { useRef, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import {convertStringToNumber} from 'convert-string-to-number'

import Layout from "../components/Layout/Layout";
import NavBar from '../components/NavBar/NavBar';

import { getFlipStatus } from "../api/getFlipStatus";

import { updateBoostLevel } from "../api/updateBoostLevel";

import { formatUserCount } from "../utils/formatUserCount";

import moveIcon from '../assets/moveIcon.png';
import tickIcon from '../assets/tickIcon.png';
import notificationIcon from '../assets/notificationIcon.png';
import multiTapIcon from '../assets/multiTapIcon.png';
import energyIcon from '../assets/energy.png';
import astronautIcon from '../assets/astronaut.png';
import dotIcon from '../assets/dot.png';
import closeIcon from '../assets/closeIcon.png';
import workoutIcon from '../assets/energy_modal.png';

import { formatNumber } from "../utils/formatNumber";

const Earn = () => {
    const token = sessionStorage.getItem('token');
    const points = sessionStorage.getItem('points');
    // const level = sessionStorage.getItem('level');
    const level = Number(localStorage.getItem("level"));
    const [multiTapLevel, setMultiTapLevel] = useState(0);
    const [dailyAttemptsLevel, setDailyAttemptsLevel] = useState(0);
    const navigate = useNavigate();
    const dropdownRef = useRef(null);
    const [notification, setNotification] = useState('');
    const [notificationVisibile, setNotificationVisibile] = useState(false);
    const [dropdownVisible, setDropdownVisible] = useState(false);
    const [boostType, setBoostType] = useState('');
    const [score, setScore] = useState(0);
    const [mode, setMode] = useState(true);

    const requiredScoreForMultiTap = 2000 * (2 ** multiTapLevel);
    const requiredScoreForDailyAttempts = 2000 * (2 ** dailyAttemptsLevel);
    const formattedScoreForMultiTap = formatNumber(requiredScoreForMultiTap);
    const formattedScoreForDailyAttempts = formatNumber(requiredScoreForDailyAttempts);
    useEffect(()=>{
        let ml = sessionStorage.getItem('multiTapLevel');
        ml = convertStringToNumber(ml);
        setMultiTapLevel(ml);
        let dl = sessionStorage.getItem('dailyAttemptsLevel');
        dl = convertStringToNumber(dl);
        setDailyAttemptsLevel(dl);
        const pnts = sessionStorage.getItem('points');
        setScore(pnts); 
    }, [])
    const handleClickDouble = () => {
        navigate('/flip');
    }

    const handleClickMultiTap = () => {
        setBoostType('multiTap');
        setDropdownVisible(!dropdownVisible);
    }

    const handleClickDailyAttempts = () => {
        setBoostType('dailyAttempts');
        setDropdownVisible(!dropdownVisible);
    }

    const handleClickMultiTapGet = async () => {
        const result = await updateBoostLevel(token, 'multiTap');
        if (result == true) {
            setScore(score - requiredScoreForMultiTap);
            setMultiTapLevel(multiTapLevel + 1);
            setDropdownVisible(!dropdownVisible);
            setNotification('Multitap successfully added');
            setNotificationVisibile(true);
            setTimeout(() => {
                setNotificationVisibile(false);
                setTimeout(() => setNotification(''), 3000);
            }, 2000);
        }
    }

    useEffect(()=>{
        const setFlipStatus = async () => {
            const flipStatus = await getFlipStatus(token);
            setMode(flipStatus);
        }
        setFlipStatus();
    }, [])

    const handleClickDailyAttemptsGet = async () => {
        const result = await updateBoostLevel(token, 'dailyAttempts');
        if (result == true) {
            setScore(score - requiredScoreForDailyAttempts);
            setDailyAttemptsLevel(dailyAttemptsLevel + 1);
            setDropdownVisible(!dropdownVisible);
            setNotification('Attempts successfully added');
            setNotificationVisibile(true);
            setTimeout(() => {
                setNotificationVisibile(false);
                setTimeout(() => setNotification(''), 3000);
            }, 2000);
        }
    }

    useEffect(() => {
        const handleOutsideClick = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target) && !event.target.closest('.boostButton')) {
                setDropdownVisible(false);
            }
        };

        if (dropdownVisible) {
            document.addEventListener('mousedown', handleOutsideClick);
        } else {
            document.removeEventListener('mousedown', handleOutsideClick);
        }

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [dropdownVisible, setDropdownVisible]);

    const closeDropdown = () => {
        setDropdownVisible(false);
    }

    const handleClickJoinClan = () =>{
        navigate('/joinclan');
    }

    const [clanInfo, setClanInfo] = useState({})
    const [clan, setClan] = useState(false);

    useEffect(()=>{
        if(sessionStorage.getItem("clanInfo") === "{}"){
            setClan(false);
            return;
        }
        setClan(true);
        setClanInfo(JSON.parse(sessionStorage.getItem("clanInfo")));
    }, [])

    const handleClickClan = (id) => {
        navigate(`/joinClan/${id}`);
    };

    return (
        <Layout>
            {clan ? (
                <button style={{ width: '72%', marginLeft: "auto", marginRight: "auto", borderRadius: '18.75rem', background: 'rgba(140,140,140,0.1)', backdropFilter: 'blur(0.5rem)', WebkitBackdropFilter: 'blur(0.5rem)', marginBlock: '0.3125rem', padding: '0.5rem', display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', border: 'none', gap: '0.5rem' }} onClick={() => handleClickClan(clanInfo.id)} className='clan'>
                    <img src={clanInfo.profilePictureUrl} alt="Avatar" style={{ width: '2.5rem', height: '2.5rem', position: 'relative', borderRadius: '50%' }}>
                    </img>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.3125rem', width: '100%' }}>
                        <span style={{ fontFamily: 'Poppins', fontWeight: '600', fontSize: '0.75rem', color: 'white', textAlign: 'start' }}>{clanInfo.clanName}</span>
                        {clanInfo.energyBonus > 0 && (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={energyIcon} alt="Energy Icon" style={{ width: '0.875rem', height: '0.875rem' }} />
                                <span style={{ fontFamily: 'Poppins', fontWeight: '400', fontSize: '0.5rem', color: 'white', marginLeft: '0.25rem' }}>+{clanInfo.energyBonus}</span>
                            </div>
                        )}
                        {clanInfo.tapBonus > 0 && (
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={multiTapIcon} alt="Multi Tap Icon" style={{ width: '0.875rem', height: '0.875rem' }} />
                                <span style={{ fontFamily: 'Poppins', fontWeight: '400', fontSize: '0.5rem', color: 'white', marginLeft: '0.25rem' }}>+{clanInfo.tapBonus}</span>
                            </div>
                        )}
                    </div>
                    <span style={{ fontFamily: 'Poppins', fontWeight: '500', fontSize: '0.8125rem', color: 'white', opacity: '0.6' }}>{clanInfo.points===undefined?"":formatUserCount(clanInfo.points)}{clanInfo.points > 1000 && '+'}</span>
                </button>
            ) : (
                <button style={{ width: '50%', marginLeft:"auto", marginRight:"auto" , display:"flex", justifyContent:"center" , borderRadius: '18.75rem', background: 'rgba(140,140,140,0.1)', backdropFilter: 'blur(0.5rem)', WebkitBackdropFilter: 'blur(0.5rem)', marginBlock: '0.3125rem', paddingBlock: '1rem', cursor: 'pointer', border: 'none', fontFamily: 'Poppins', color: 'white', fontSize: '1rem', fontWeight: '500' }} onClick={handleClickJoinClan} >🪐 Join Clan</button>
            )}
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%', position: 'relative' }}>
                <div style={{ marginBlock: '0.3125rem', color: 'white', fontSize: '2.5rem', fontWeight: '700', fontFamily: 'Poppins' }}>{formatNumber(score)}</div>
                <button style={{ backgroundColor: 'rgba(140, 140, 140, 0.1)', color: 'white', border: 'none', padding: '0.34375rem 2rem', fontFamily: 'Poppins', fontSize: '0.75rem', fontWeight: '500', borderRadius: '6.25rem', cursor: 'pointer' }} >Level {level}</button>
                <div style={{ width: '100%', paddingInline: '2.5rem' }}>
                    <div style={{ marginTop: '0.1875rem' }}>
                        <span style={{ color: 'white', fontFamily: 'Poppins', fontWeight: '600', fontSize: '1.5rem' }}>Boosters</span>
                    </div>
                    <div style={{ width: '100%', background: 'rgba(140,140,140,0.1)', backdropFilter: 'blur(0.5rem)', WebkitBackdropFilter: 'blur(0.5rem)', padding: '0.5625rem', borderRadius: '1.25rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexDirection: 'column', gap: '1rem' }}>
                        <button style={{ border: 'none', display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: score < requiredScoreForMultiTap ? 'auto' : 'pointer', background: 'transparent', width: '100%', opacity: score < requiredScoreForMultiTap ? '0.1' : '1' }} onClick={score < requiredScoreForMultiTap ? null : handleClickMultiTap} className="boostButton">
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={multiTapIcon} alt="MultiTap Icon" style={{ width: '2.9rem', height: '2.9rem', background: 'rgba(140,140,140,0.1)', borderRadius: '50%', padding: '0.5rem' }} />
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', marginLeft: '1rem' }}>
                                    <span style={{ fontFamily: 'Poppins', fontWeight: '600', fontSize: '0.9rem', color: 'white' }}>Multitap</span>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                                        <span style={{ fontFamily: 'Poppins', fontWeight: '500', fontSize: '0.9rem', color: 'rgba(255,255,255,0.8)' }}>{formattedScoreForMultiTap}</span>
                                        <img src={dotIcon} alt="Dot Icon" style={{ width: '0.3125rem', height: '0.3125rem' }} />
                                        <span style={{ fontFamily: 'Poppins', fontWeight: '500', fontSize: '0.8rem', color: 'rgba(255,255,255,0.6)' }}>{multiTapLevel} lvl</span>
                                    </div>
                                </div>
                            </div>
                            {score < requiredScoreForMultiTap ? (
                                <img src={tickIcon} alt="Tick Icon" style={{ width: '1.25rem', height: '1.25rem' }} />
                            ) : (
                                <img src={moveIcon} alt="Move Icon" style={{ width: '1.25rem', height: '1.25rem' }} />
                            )}
                        </button>
                        <button style={{ border: 'none', display: 'flex', justifyContent: 'space-between', alignItems: 'center', cursor: score < requiredScoreForDailyAttempts ? 'auto' : 'pointer', background: 'transparent', width: '100%', opacity: score < requiredScoreForDailyAttempts ? '0.1' : '1' }} onClick={score < requiredScoreForDailyAttempts ? null : handleClickDailyAttempts} className="boostButton">
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <img src={energyIcon} alt="Energy Icon" style={{ width: '2.9rem', height: '2.9rem', background: 'rgba(140,140,140,0.1)', borderRadius: '50%', padding: '0.5rem' }} />
                                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'start', marginLeft: '1rem' }}>
                                    <span style={{ fontFamily: 'Poppins', fontWeight: '600', fontSize: '0.9rem', color: 'white' }}>Daily Attempts</span>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '0.6rem' }}>
                                        <span style={{ fontFamily: 'Poppins', fontWeight: '500', fontSize: '0.9rem', color: 'rgba(255,255,255,0.8)' }}>{formattedScoreForDailyAttempts}</span>
                                        <img src={dotIcon} alt="Dot Icon" style={{ width: '0.3125rem', height: '0.3125rem' }} />
                                        <span style={{ fontFamily: 'Poppins', fontWeight: '500', fontSize: '0.8rem', color: 'rgba(255,255,255,0.6)' }}>{dailyAttemptsLevel} lvl</span>
                                    </div>
                                </div>
                            </div>
                            {score < requiredScoreForDailyAttempts ? (
                                <img src={tickIcon} alt="Tick Icon" style={{ width: '1.25rem', height: '1.25rem' }} />
                            ) : (
                                <img src={moveIcon} alt="Move Icon" style={{ width: '1.25rem', height: '1.25rem' }} />
                            )}
                        </button>
                    </div>
                    {mode?<div style={{ width: '100%', background: 'rgba(140,140,140,0.1)', backdropFilter: 'blur(0.5rem)', WebkitBackdropFilter: 'blur(0.5rem)', padding: '1rem', marginTop: '1rem', borderRadius: '1.25rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexDirection: 'column' }}>
                        <div style={{display:"flex", flexDirection:"column", justifyContent:"center", alignItems:"center"}}>
                            <img src={astronautIcon} alt="Astronaut Icon" style={{ width: '6.25rem', height: '6.25rem' }} />
                            <span style={{marginLeft:"5px" ,fontFamily: 'Poppins', fontWeight: '600', fontSize: '1.2rem', color: 'white', marginTop: '0.5rem' }}>Mooncoin Game x2</span>
                        </div>
                        <span style={{ fontFamily: 'Poppins', fontWeight: '400', fontSize: '0.8rem', color: '#F1F1F1', marginTop: '0.5rem', textAlign: 'center' }}>Double your Coins and Level Up even Faster!</span>
                        <button style={{ width: '89%', background: 'linear-gradient(45deg, #5DA8FF, #0064D7)', paddingBlock: '0.7rem', border: 'none', marginTop: '1rem', borderRadius: '18.75rem', color: 'white', fontFamily: 'Poppins', fontSize: '0.8rem', cursor: 'pointer', fontWeight: '500' }} onClick={handleClickDouble}>
                            Double
                        </button>
                    </div>:<div style={{ marginTop: '1rem', width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center', borderRadius: '1.25rem', background: 'rgba(140,140,140,0.1)', backdropFilter: 'blur(0.5rem)', WebkitBackdropFilter: 'blur(0.5rem)', padding: '1rem' }}>
                                <img src={workoutIcon} alt="Work Out Icon" style={{ width: '6.25rem', height: '5.7rem' }} />
                                <span style={{ marginTop: '0.5rem', fontFamily: 'Poppins', fontWeight: '600', fontSize: '1.2rem', color: 'white', textAlign: 'center' }}>Loading...</span>
                                <span style={{ marginTop: '0.5rem', fontFamily: 'Poppins', fontWeight: '400', fontSize: '0.8rem', color: '#F1F1F1', textAlign: 'center' }}>Come back tomorrow or continue</span>
                                <span style={{ marginTop: '0.5rem', fontFamily: 'Poppins', fontWeight: '400', fontSize: '0.8rem', color: '#F1F1F1', textAlign: 'center' }}>tapping on the coin</span>
                                <button style={{ width: '88%', opacity:0.5 , background: 'linear-gradient(45deg, #5DA8FF, #0064D7)', paddingBlock: '0.7rem', border: 'none', marginTop: '1rem', borderRadius: '18.75rem', color: 'white', fontFamily: 'Poppins', fontSize: '0.8rem', cursor: 'pointer', fontWeight: '500' }}>
                                    Double
                                </button>
                            </div>}
                </div>
                {notification &&
                    <div style={{ position: 'absolute', bottom: '8rem', zIndex: '2', width: '100%' }}>
                        <div style={{ marginInline: '1.875rem', background: 'rgba(140, 140, 140, 0.1)', backdropFilter: 'blur(1rem)', WebkitBackdropFilter: 'blur(0.5rem)', borderRadius: '18.75rem', paddingBlock: '1rem', display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: notificationVisibile ? 1 : 0, transition: 'opacity 0.5s ease-out', pointerEvents: notificationVisibile ? 'auto' : 'none' }}>
                            <img src={notificationIcon} alt='Notification Icon' style={{ width: '1.5625rem', height: '1.5625rem' }} />
                            <span style={{ fontFamily: 'Poppins', fontWeight: '600', fontSize: '1.1rem', color: 'white', marginLeft: '0.375rem' }}>{notification}</span>
                        </div>
                    </div>
                }
            </div>
            {dropdownVisible && (
                <div style={{width:'100vw', height:'100vh', backdropFilter: "blur(18px)", backgroundColor: "#00000059" , display:'flex', justifyContent:'center', alignItems:'center', position:'fixed', top:'0px'}}>
                <div ref={dropdownRef} style={{ width: '82%' , borderRadius: '1.25rem', background: 'rgba(140,140,140,0.1)', backdropFilter: 'blur(3rem)', WebkitBackdropFilter: 'blur(3rem)', flexDirection: 'column', padding: '1rem', display:'flex', justifyContent:'center', alignItems: 'center' }}>
                    <button style={{ position: 'absolute', top: '1rem', right: '1rem', float: 'right', background: 'none', border: 'none', cursor: 'pointer' }} onClick={closeDropdown} >
                        <img src={closeIcon} alt="Close Icon" style={{ width: '1.875rem', height: '1.875rem' }} />
                    </button>
                    <img src={boostType == 'multiTap' ? multiTapIcon : energyIcon} alt={boostType == 'multiTap' ? "Multi Tap Icon" : "Energy Icon"} style={{ width: '4rem', height: '4rem' }} />
                    <span style={{ marginTop: '1.2025rem', fontFamily: 'Poppins', fontWeight: '600', fontSize: '1.25rem', color: 'white' }}>{boostType == 'multiTap' ? 'Multi Tap' : 'Daily Attempts'}</span>
                    <span style={{ marginTop: '1rem', fontFamily: 'Poppins', fontWeight: '300', fontSize: '0.8rem', color: '#F1F1F1', textAlign: 'center' }}>{boostType == 'multiTap' ? (
                        <>
                            Increase the mount of Mooncoins
                            <br />
                            you can earn per tap
                        </>
                    ) : (
                        <>
                            Increase your Daily Attempts limit,
                            <br />
                            so you can Mine More per Session.
                        </>
                    )}</span>
                    <span style={{ fontFamily: 'Poppins', fontWeight: '400', fontSize: '0.9rem', color: '#F1F1F1', opacity: '0.6', marginTop: '1.3625rem' }}>{boostType == 'multiTap' ? '+1 per Tap for Each level' : '+1 attempt for Each level'}</span>
                    <span style={{ marginTop: '1.25rem', fontFamily: 'Poppins', fontWeight: '700', fontSize: '1.3rem', color: 'white' }}>{boostType == 'multiTap' ? formattedScoreForMultiTap : formattedScoreForDailyAttempts}</span>
                    <button style={{ marginTop: '1rem', borderRadius: '18.75rem', background: 'linear-gradient(45deg, #5DA8FF, #0064D7)', width: '83%', marginBottom:"6px" , paddingBlock: '0.4rem', color: 'white', fontFamily: 'Poppins', fontWeight: '600', fontSize: '1rem', cursor: 'pointer', border: 'none' }} onClick={boostType == 'multiTap' ? handleClickMultiTapGet : handleClickDailyAttemptsGet}>Get</button>
                </div>
                </div>
            )
            }
            <div style={{height: '65px'}}></div>
            <NavBar />
        </ Layout >
    );
};

export default Earn;